let Url, ApiUrl, BaseUrl, resourceUrl;
let domainUrl = 'youhaozhuan.com';
if (process.env.NODE_ENV === 'development' || (window.location.host).indexOf('ygdev-') > -1) {
    ApiUrl = 'https://ygdev-api.' + domainUrl + '/';
    BaseUrl = 'https://ygdev-app.' + domainUrl + '/';
    resourceUrl = '//ygdev-resource.' + domainUrl + '/';
} else {
    ApiUrl = 'https://api.' + domainUrl + '/';
    BaseUrl = 'https://app.' + domainUrl + '/';
    resourceUrl = '//resource.' + domainUrl + '/';
}
Url = 'www.' + domainUrl;
export {
    Url,
    ApiUrl,
    BaseUrl,
    resourceUrl
}
